<template>
    <div class="survey-list">
        <header>
            <h1>Encuesta diagnóstico.</h1>
            <SwitchButtons name="surveys" :values="types" @tipo="fillDataDiagnostic" />
            <div class="father">
                <div v-if="this.surveysType === 'actives'" @click="openModal" class="add-container">
                    <p>+</p>
                </div>
                <div class="survey-container" v-for="(item, index) in surveyToShow" :key="index">
                    <div class="title">
                        <div class="card-titulo">
                            <h4>{{ item.name }}</h4>
                            <div class="quickSurvey-img">
                                <img v-if="item.surveyType === 'quickSurvey'" src="@/assets/img/icon/lightning.png"
                                    title="Encuesta rápida" />
                                <img v-if="item.isEvent" src="@/assets/img/icon/boleto.png"
                                    title="Encuesta de eventos" />
                                <!-- <img
                    v-if="item.anonymous"
                    src="@/assets/img/icon/anonymous.svg"
                    title="Encuesta Anonima"
                  />-->
                            </div>
                        </div>
                        <small class="sm-gray">
                            {{ dateFormat(item.validFrom) }} a
                            {{ dateFormat(item.validTo) }}
                        </small>
                    </div>
                    <div class="body">
                        <p>{{ item.details }}</p>
                    </div>
                    <div class="body-details">
                        <small class="sm-gray mb-2">
                            {{ $t("surveys.status") }}:
                            <span v-if="item.isActive">{{ $t("surveys.active") }}</span>
                            <span v-if="!item.isActive">{{ $t("surveys.inactive") }}</span>
                        </small>
                        <div class="answer-details mb-2" v-if="item.surveysEnded > 0">
                            <small class="sm-gray mr-1">{{ item.surveysEnded }} respondidas</small>
                            <router-link :to="{
                                name: 'Diagnostic Detail',
                                id:item.id,
                                params: {
                                    id: item.id,
                                    surveyObj: item

                                }
                            }">
                                <div class="content smaller">
                                    <span>{{ $t("surveys.newSurvey.seeDetails") }}</span>
                                    <i class="fas fa-chevron-right ml-1"></i>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="left-controls mb-2">
                        <!-- Edit -->

                        <i 
                            @click="openRenameModal(item)" class="far fa-edit"></i>
                        <!-- Delete -->
                        <i v-if="userRole === 'SuperAdmin' && item.surveysEnded == 0 && item.assignedUsers.length == 0" @click="openDeleteModal(item.id)"
                            class="far fa-trash-alt"></i>
                        <i v-if="surveysType === 'actives'" @click="openCloneModal(item)" class="far fa-clone"></i>
                    </div>
                    <!--<div class="buttons">
                        <router-link v-if="surveysType === 'actives' || surveysType === 'unpublished'" :to="{
                            name: 'Edit Diagnostic',
                            params: {
                                id: item.idSurvey,
                                surveyType: item.surveyType,
                                surveyObj: item
                            }
                        }">
                            <div class="content">
                                <span v-if="+item.surveyPercentAnswers === 0">{{ $t("surveys.edit") }}</span>
                                <span v-if="+item.surveyPercentAnswers !== 0">{{ $t("surveys.newSurvey.seeContent")
                                    }}</span>
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </router-link>
                    </div>-->

                    <div class="buttons">
                        <router-link v-if="(surveysType === 'actives' || surveysType === 'unpublished') && item.surveysEnded == 0" :to="{
                            name: 'Edit Diagnostic',
                            params: {
                                id: item.id,
                                surveyType: item.surveyType,
                                surveyObj: item,
                                typeAccion:'edit',
                                typeTemplate: 'normal'
                            }
                        }">
                            <div class="content">
                                <span>{{ $t("surveys.edit") }}</span>
                               
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </router-link>
                        <router-link v-if="(surveysType === 'actives' || surveysType === 'unpublished') && item.surveysEnded > 0" :to="{
                            name: 'Edit Diagnostic',
                            params: {
                                id: item.id,
                                surveyType: item.surveyType,
                                surveyObj: item,
                                typeAccion:'clone',
                                typeTemplate: 'normal',
                                surveysEnded:item.surveysEnded
                            }
                        }">
                            <div class="content">
                                <span >{{ $t("surveys.newSurvey.seeContent")
                                    }}</span>
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <Modal v-if="modalActive" v-on:closeModal="closeModal">
                <template #header>
                    <h6 v-if="newModal" class="modal-title">{{ $t("surveys.modal.title") }}</h6>
                    <h6 v-if="deleteModal" class="modal-title">{{ $t("surveys.modal.deleteTitle") }}</h6>
                    <h6 v-if="renameModal" class="modal-title">{{ $t("surveys.modal.renameTitle") }}</h6>
                    <h6 v-if="cloneModal" class="modal-title">{{ $t("surveys.attention") }}</h6>
                </template>
                <template>
                    <div v-if="error">
                        <b-alert v-model="error" variant="danger" dismissible id="alert-modal">Es necesario llenar todos
                            los campos!</b-alert>
                    </div>
                    <div v-if="newModal">
                        <label for>{{ $t("surveys.modal.titleSurvey") }}</label>
                        <input type="text" v-model="name" />
                        <v-select inputId="select-search-input"
                            :options="[
                                { label: 'Encuesta normal', value: 'normal', bool: false },
                                ...arrayTemplates
                            ]"
                            v-model="select">
                        </v-select>
                    </div>
                    <div v-if="renameModal">
                        <label for>{{ $t("surveys.modal.renameBody") }}</label>
                        <input type="text" v-model="rename" />
                    </div>
                    <div v-if="deleteModal">
                        <p>{{ $t("surveys.modal.deleteQuestion") }}</p>
                    </div>
                    <div v-if="cloneModal">
                        <p>{{ $t("surveys.cloneAlert") }}</p>
                        <p>{{ $t("surveys.sureText") }}</p>
                    </div>
                </template>
                <template #footer>
                    <div v-if="newModal" class="controls">
                        <span class="control cancel-btn" @click="closeModal">{{ $t("surveys.modal.cancel") }}</span>
                        <button type="control button" class="btn-save" @click="validateForm">{{ $t("surveys.modal.save")
                            }}</button>
                    </div>
                    <div v-if="deleteModal" class="controls">
                        <span class="control cancel-btn" @click="closeModal">{{ $t("surveys.modal.cancel") }}</span>
                        <button type="control button" class="btn-save" :disabled="isLoading"
                            @click="deleteSurvey(surveyId)">{{ $t("surveys.modal.deleteButton") }}</button>
                    </div>
                    <div v-if="renameModal" class="controls">
                        <span class="control cancel-btn" @click="closeModal">{{ $t("surveys.modal.cancel") }}</span>
                        <button type="control button" class="btn-save" :disabled="isLoading" @click="validateEdit">{{
                            $t("surveys.modal.save") }}</button>
                    </div>
                    <div v-if="cloneModal" class="controls">
                        <span class="control cancel-btn" @click="closeModal">{{ $t("surveys.modal.cancel") }}</span>
                        <button type="control button" class="btn-save" @click="cloneSurveyAction">{{
                            $t("surveys.cloneBtn") }}</button>
                    </div>
                </template>
            </Modal>
        </header>
    </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Surveys.js";
import API_SERVICES from "@/lib/api/Diagnostic.js";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import momentTimezone from 'moment-timezone';
const SwitchButtons = () => import("@/components/Switch");
const Modal = () => import("@/components/Modal");
const api = new API_SERVICE();
const api_diagnostic = new API_SERVICES();

export default {
    components: {
        Modal,
        SwitchButtons,
    },
    props: ["values", "onChange"],
    data() {
        return {
            arrayTemplates:[],
            activesTitle: "",
            historyTitle: "",
            modalActive: false,
            surveys: [],
            surveysHistory: [],
            surveyToShow: [],
            listTemplates:[],
            newModal: false,
            deleteModal: false,
            renameModal: false,
            surveyObj: null,
            surveyId: "",
            select: "",
            name: "",
            rename: "",
            isLoading: false,
            active: false,
            error: false,
            surveysType: "actives",
            surveyPercentAnswers: "0",
            surveyType: "",
            cloneModal: false,
        };
    },

    beforeMount: async function () {
        //await this.fillData("actives");
        await this.fillDataDiagnostic("actives");
        await this.getTemplates();
    },

    methods: {
        openModal: function () {
            this.modalActive = true;
            this.newModal = true;
            this.deleteModal = false;
        },
        dateFormat: function (date) {
            return moment(date).locale(this.$i18n.locale).format("LL");
        },
        openDeleteModal: function (id) {
            this.modalActive = true;
            this.deleteModal = true;
            this.newModal = false;
            this.renameModal = false;
            this.surveyId = id;
        },
        openRenameModal: function (object) {
            this.modalActive = true;
            this.renameModal = true;
            this.newModal = false;
            this.deleteModal = false;
            this.rename = object.name;
            this.surveyObj = object;
        },
        openCloneModal(object) {
            this.modalActive = true;
            this.cloneModal = true;
            this.surveyObj = object;
        },
        closeModal: function () {
            this.modalActive = false;
            this.deleteModal = false;
            this.renameModal = false;
            this.newModal = false;
            this.select = "";
            this.name = "";
            this.rename = "";
            this.error = false;
            this.cloneModal = false;
        },
        validateForm: function (item) {
            if (!this.select || !this.name) {
                this.error = true;
            } else {
                try {
                    this.error = false;
                    this.createSurvey();
                } catch (error) {
                    throw error;
                }
            }
        },
        validateEdit: function () {
            if (this.rename === "") {
                this.error = true;
            } else {
                try {
                    this.error = false;
                    this.editSurvey();
                } catch (error) {
                }
            }
        },
        fillData: async function (type) {
            this.$store.commit("global/SET_LOADING", true);
            try {
                this.surveysType = type;
                let params = {
                    filterBy: type,
                };
                const resp = await api.getAllSurveys(params);
                this.surveyToShow = resp.surveysInfo;
                this.surveyPercentAnswers = +resp.surveysInfo.surveyPercentAnswers;

                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },
        fillDataDiagnostic: async function (type) {
            this.$store.commit("global/SET_LOADING", true);
            try {
                this.surveysType = type;
                const resp = await api_diagnostic.getAllSurveys(type);
                this.surveyToShow = resp.items;

                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },
        getTemplates:async function () {
            this.$store.commit("global/SET_LOADING", true);
            try {

                const resp = await api_diagnostic.getTemplates();
                this.listTemplates=resp.items.reverse();
                for(let i=0;i<resp.items.length;i++){
                    this.arrayTemplates=[...this.arrayTemplates, { label: resp.items[i].name, value: resp.items[i].id, bool: false }]
                }
                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },

        deleteSurvey: async function (id) {
            this.$store.commit("global/SET_LOADING", true);
            try {
                const resp = await api_diagnostic.deleteQuestionData(id);
                this.active = false;
                await this.fillDataDiagnostic("actives");
                //await this.fillData(this.surveysType);
                this.closeModal();
                this.$store.commit("global/SET_LOADING", false);
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }
        },
        createSurvey: async function () {
            let dateFrom = momentTimezone().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm')
            let dateTo = momentTimezone().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm')

            this.$store.commit("global/SET_LOADING", true);
            
            if(this.select.value != "normal"){
                
                const temporal = {
                            "id": 42,
                            "surveyObj": {
                                "name": this.name,
                                "details": "-",
                                "points": 0,
                                "id": 42,
                                "validFrom": dateFrom,
                                "validTo": dateTo,
                                "surveyType":"type"
                            },
                            "typeTemplate":this.select.value,
                            "typeAccion":"template",
                            "nameDesing":this.name,
                            "firstTime": true,
                            "surveyType": "multipleOptionSurvey"
                        };
                        
                        this.$router.push({
                            name: "Edit Diagnostic",
                            //params: { id, surveyType: type, surveyObj, firstTime: true },
                            params: temporal
                        });
                
            }else{
            try {
                let params = {
                    name: this.name,
                    details: "-",
                    //validFrom: dateFrom,
                    //validTo: dateTo,
                    points: 0,
                    isActive: true,
                    isPublished: false,
                    estimatedTime: 1,
                };
                const resp = await api_diagnostic.createSurvey(params);
                
                    this.closeModal();
                    this.$store.commit("global/SET_LOADING", false);
                    const id = resp.id;
                    
                        const temporal = {
                            "id": id,
                            "surveyObj": {
                                "name": this.name,
                                "details": "-",
                                "points": 0,
                                "id": id,
                                "validFrom": dateFrom,
                                "validTo": dateTo,
                                "surveyType":"type"
                            },
                            "typeAccion":"create",
                            "typeTemplate":"normal",
                            "firstTime": true,
                            "surveyType": "multipleOptionSurvey"
                        };
                        
                        this.$router.push({
                            name: "Edit Diagnostic",
                            //params: { id, surveyType: type, surveyObj, firstTime: true },
                            params: temporal
                        });
                
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                throw error;
            }

            }
            this.$store.commit("global/SET_LOADING", false);
        },
        editSurvey: async function () {
            this.$store.commit("global/SET_LOADING", true);
            this.isLoading = true;
            try {
                /*let survey = {
                    assignedUsers: this.surveyObj.assignedUsers,
                    idSurvey: this.surveyObj.idSurvey,
                    name: this.rename,
                    details: this.surveyObj.details,
                    validFrom: this.surveyObj.validFrom,
                    validTo: this.surveyObj.validTo,
                    points: this.surveyObj.points,
                    surveyType: this.surveyObj.surveyType,
                    surveyActive: this.surveyObj.surveyActive,
                    questions: this.surveyObj.questions,
                    surveyEstimatedTime: this.surveyObj.surveyEstimatedTime,
                    surveyPublished: this.surveyObj.surveyPublished,
                };*/
                let survey = {
                    "name": this.rename,
                    "details": this.surveyObj.details || "",
                    "assignedUsers": this.surveyObj.assignedUsers,
                    "isActive": this.surveyObj.isActive,
                    
                }

                const resp = await api_diagnostic.editSurvey(survey,this.surveyObj.id);
                this.active = false;
                await this.fillDataDiagnostic("actives");

                this.closeModal();
                this.$store.commit("global/SET_LOADING", false);
                this.isLoading = false;
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
                this.isLoading = false;
                throw error;
            }
        },
        async cloneSurveyAction() {
            this.$store.commit("global/SET_LOADING", true);
            try { 
                console.log(this.surveyObj);
                
                const resp = await api_diagnostic.cloneSurvey(this.surveyObj.id);
                console.log("resp=======>",resp);
                
                    this.$router.push({
                        name: 'Edit Diagnostic',
                            params: {
                                id: resp.id,
                                surveyType: "multipleOptionSurvey",
                                surveyObj: this.surveyObj,
                                typeAccion:'clone',
                                typeTemplate: 'normal',
                                surveysEnded:1
                            },
                    });
                
            } catch (error) {
                this.$store.commit("global/SET_LOADING", false);
            } finally {
                this.$store.commit("global/SET_LOADING", false);
                this.closeModal();
            }
        },
    },
    computed: {
        userRole() {
            return this.$store.getters["session/role"];
        },
        types: function () {
            return [
                {
                    label: this.$t("surveys.tabs.tab1"),
                    value: "actives",
                },
                {
                    label: this.$t("surveys.tabs.tab2"),
                    value: "history",
                },
                {
                    label: this.$t("surveys.tabs.tab3"),
                    value: "published",
                },
                {
                    label: this.$t("surveys.tabs.tab4"),
                    value: "unpublished",
                },
            ];
        },
    },
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";

@font-face {
    font-family: "audi-normal";
    src: url("~@/assets/fonts/AudiTypeScreen-Normal.ttf");
    font-weight: normal;
}

@font-face {
    font-family: "audi-bold";
    src: url("~@/assets/fonts/AudiTypeScreen-Bold.ttf");
    font-weight: bold;
}

.vue-tablist {
    list-style: none;
    display: flex;
    padding-left: 0;
}

.vue-tab {
    padding: 5px 10px;
    cursor: pointer;
    user-select: none;
    background: #d9d9d9;
    position: relative;
    bottom: -1px;
    font-family: "audi-normal";
}

.vue-tab[aria-selected="true"] {
    background: #333333;
    color: white;
    font-family: "audi-bold";
}

.vue-tab[aria-disabled="true"] {
    cursor: not-allowed;
    color: #999;
}

.add-container {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 10rem;
    max-width: 26rem;
    height: 200px;
    margin: 20px;
    background-color: #ffffff;
    padding: 20px 20px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    display: grid;
    grid-template-rows: 1fr 1fr auto;
    grid-template-columns: 1fr;
    grid-template-areas: "head" "body" "foot";
    position: relative;
}

.isDisabled {
    cursor: not-allowed;
    pointer-events: none;
}

.add-container p {
    font-size: 50px;
    color: #666666;
    font-family: "audi", sans-serif;
    font-weight: normal;
    position: absolute;
    top: 30%;
    left: 40%;
}

.survey-container {
    width: 100%;
    max-width: 26rem;
    height: 200px;
    margin: 20px;
    background-color: #ffffff;
    padding: 20px 20px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    display: grid;
    grid-template-rows: 1fr 1fr auto;
    grid-template-columns: 1fr;
    grid-template-areas: "head" "body" "foot";
    position: relative;
}

.survey-container .title {
    color: #333333;
}

.survey-container .card-titulo {
    width: 100%;
    display: flex;
}

.survey-container .card-titulo h4 {
    width: 95%;
}

.survey-container .card-titulo .quickSurvey-img {
    width: 5%;
}

.survey-container .sm-gray {
    color: #b3b3b3;
    font-family: "audi-normal";
}

.survey-container .sm-gray span {
    color: #666666;
    font-family: "audi-normal";
}

.survey-container .body {
    color: #333333;
    font-size: 15px;
    overflow-y: scroll;
}

.survey-container .buttons {
    position: absolute;
    top: 80%;
    right: 5%;
    text-align: right;
}

.survey-container .left-controls {
    display: flex;
    align-items: center;
}

.survey-container .left-controls i {
    font-size: 1.3rem;
    margin-right: 1rem;
    cursor: pointer;
}

.survey-container .buttons a {
    color: #333333;
    cursor: pointer;
    font-family: "audi", sans-serif;
    font-weight: normal;
}

.survey-container .buttons span {
    margin-right: 1rem;
    color: #333333;
    cursor: pointer;
    font-family: "audi", sans-serif;
    font-weight: normal;
}

.survey-container .buttons span:hover {
    text-decoration: underline;
}

.survey-container .buttons .delete-btn:hover {
    color: #bb0a30;
}

.survey-container .buttons i {
    margin-left: -0.5rem;
}

.father {
    display: flex;
    flex-wrap: wrap;
}

.survey-list .modal-container {
    background-color: #ffffff;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    max-width: 60vw;
    max-height: 60vh;
}

.survey-list .body-details {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.survey-list .body-details .answer-details {
    display: flex;
    align-items: center;
}

.survey-list .smaller {
    color: #000;
}

.survey-list .smaller i {
    font-size: 0.7rem;
}

.alert-modal {
    width: 100%;
}

.survey-list .modal-title {
    margin: 0;
}

.survey-list .controls {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}

.survey-list .controls .control {
    margin-left: 15px;
    font-size: 16px;
    cursor: pointer;
}

.survey-list .controls .control .cancel-btn {
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    margin-left: 15px;
}

.survey-list .control .cancel-btn:hover {
    text-decoration: underline;
}

.survey-list .btn-save {
    font-family: "audi-bold";
    color: #fff;
    background-color: #000;
    border-color: #000;
    padding: 10px 20px;
    border-radius: 0px;
    border: none;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    margin-left: 15px;

    &:hover {
        background-color: #bb0a30;
        border-color: #bb0a30;
        text-decoration: none;
        color: white;
    }
}

.v-select {
    width: 100%;
}

.vs__dropdown-toggle {
    color: $bg_1;
    border: none;
    border-bottom: 1px solid $wg_1;
    border-radius: 0;
}

#select-search-input {
    width: 0%;
    border: none;
}

.vs__dropdown-option:hover {
    background-color: $wg_3;
    color: $black;
}

.vs__dropdown-option--selected {
    background-color: $b_2;
    color: $white;
}

.vs__dropdown-option--highlight {
    background-color: $wg_3;
    color: $black;
}

.vs__actions {
    cursor: pointer;
}

.layout {
    display: flex;
    margin: 0 20px;
}

/* The switch-item */
.switch-item {
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.switch-item input {
    opacity: 0;
    height: 0;
    width: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    height: 100%;
    width: 100%;
    background-color: #ddd;
    padding: 16px;
    transition: all 100ms linear;
}

/* On mouse-over, add a grey background color */
.switch-item:hover input~.checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.switch-item input:checked~.checkmark {
    background-color: #333;
    color: white;
    font-weight: bold;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    position: absolute;
    display: none;
}

.survey-list .modal-container {
    width: 20vw !important;
}

.content span {
    text-transform: uppercase;
}
</style>